import { render } from "./CheckoutMeditationCourseTitle.vue?vue&type=template&id=08c845de"
import script from "./CheckoutMeditationCourseTitle.vue?vue&type=script&lang=js"
export * from "./CheckoutMeditationCourseTitle.vue?vue&type=script&lang=js"

import "./CheckoutMeditationCourseTitle.vue?vue&type=style&index=0&id=08c845de&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__